/**
 * Top bar system constants — single source of truth for all top nav
 * icon buttons, colors, and shared utilities.
 */

/** Shared color palette for the TopBar, UserMenu, and NotificationBell. */
export const TOPBAR_COLORS = {
  surface: 'transparent',
  header: 'var(--color-primary-500)',
  interactive: 'rgba(255, 255, 255, 0.2)',
  border: 'rgba(148, 163, 184, 0.3)',
  shadow: 'rgba(0,0,0,0.06)',
  /** Softer shadow for dropdown panels and notification items */
  panelShadow: 'rgba(0,0,0,0.08)',
  text: '#1e293b',
  textLight: '#ffffff',
  danger: '#fef2f2',
  badge: '#F1F2F5',
  unread: '#F1F2F5',
} as const;

/**
 * Circular icon button design tokens.
 *
 * Minimalist healthcare style:
 * — Subtle border at rest
 * — Soft shadow on hover
 */
export const ICON_BUTTON = {
  /** Button diameter (px) */
  size: 48,
  /** Icon size inside the button (Tailwind class) */
  iconSize: 'h-6 w-6',
  /** Border width + color */
  border: '1px solid #e2e8f0',
  /** Background at rest */
  bg: '#ffffff',
  /** Box-shadow at rest — none */
  shadow: 'none',
  /** Box-shadow on hover — soft */
  hoverShadow: '0 2px 4px rgba(0,0,0,0.06)',
} as const;
